'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@algoacademy/design-system/shared/cn';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  const $ = _c(15);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="absolute inset-0 bg-dot-grid opacity-40" />;
    t1 = <div aria-hidden="true" className="absolute top-[-10rem] left-1/2 h-[32rem] w-[64rem] -translate-x-1/2 rounded-full bg-algoprimary/20 blur-3xl" />;
    t2 = <div aria-hidden="true" className="absolute right-[-8rem] bottom-[-12rem] h-[28rem] w-[28rem] rounded-full bg-algosecondary/15 blur-3xl" />;
    t3 = cn("relative flex flex-col items-center gap-8 px-6 py-32 text-center sm:py-40");
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 12
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <motion.span initial={t4} animate={t5} transition={t6} className="inline-flex items-center gap-2 rounded-full border border-borderPrimary bg-backgroundPrimary/60 px-4 py-1.5 font-mono text-contentTertiary text-xs uppercase tracking-widest backdrop-blur"><span className="size-1.5 rounded-full bg-algoprimary" />AlgoAcademy Labs</motion.span>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <motion.h1 initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.1,
      ease: "easeOut"
    }} className={cn("bg-gradient-to-br from-contentPrimary to-algoprimary bg-clip-text font-bold text-7xl text-transparent leading-none tracking-tight sm:text-9xl")}>Algolabs</motion.h1>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.25,
      ease: "easeOut"
    }} className="max-w-2xl font-light text-2xl text-contentSecondary leading-relaxed sm:text-3xl">Inkubator startupow edukacyjnych z AlgoAcademy</motion.p>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.4,
      ease: "easeOut"
    }} className="max-w-3xl text-contentTertiary text-lg leading-relaxed">Tworzymy aplikacje edukacyjne nowej generacji. Eksperymentujemy z AI, mentoringiem i nowymi sposobami nauki.</motion.p>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  let t12;
  let t13;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 0,
      y: 16
    };
    t12 = {
      opacity: 1,
      y: 0
    };
    t13 = {
      duration: 0.7,
      delay: 0.55,
      ease: "easeOut"
    };
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <section className="relative overflow-hidden">{t0}{t1}{t2}<div className={t3}>{t7}{t8}{t9}{t10}<motion.div initial={t11} animate={t12} transition={t13} className="flex flex-col items-center gap-4 sm:flex-row"><Button href="/aplikacje" size="xl">Zobacz nasze aplikacje</Button><Button href="/o-nas" size="xl" outline={true}>Poznaj Algolabs</Button></motion.div></div></section>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  return t14;
}